import { render, staticRenderFns } from "./RolePermissionsModal.vue?vue&type=template&id=ff3c2b36&scoped=true&"
import script from "./RolePermissionsModal.vue?vue&type=script&lang=js&"
export * from "./RolePermissionsModal.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionsModal.vue?vue&type=style&index=0&id=ff3c2b36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3c2b36",
  null
  
)

export default component.exports